/*
  Verifica del CAP.

  Il negozio consegna a due condizioni diverse: sui CAP della lista di Giuliano
  ci va il suo corriere (5,99 €, 3-5 giorni, e il pacco si puo' provare prima di
  pagare), su tutto il resto d'Italia ci va GLS (9,99 €, 5-7 giorni, niente
  prova). Nessuno resta fuori: cambia solo quale delle due tocca.

  Per questo qui non c'e' un "si" e un "no". Le due risposte sono due notizie
  diverse, non una buona e una cattiva, e il colore lo dice: verde la prima,
  bianco la seconda. Il rosso vorrebbe dire "non ti serviamo", che e' falso.

  L'elenco dei CAP arriva dall'attributo data-, cioe' dalle impostazioni della
  sezione: quando Giuliano allarga la zona lo cambia dal tema, senza toccare
  questo file.
*/
(() => {
  const soloCifre = (v) => (v || '').replace(/\D/g, '').slice(0, 5);

  const attiva = (radice) => {
    const elenco = new Set(
      (radice.dataset.gsCapElenco || '')
        .split(',')
        .map((c) => soloCifre(c))
        .filter((c) => c.length === 5)
    );
    const form = radice.querySelector('[data-gs-cap-form]');
    const campo = radice.querySelector('[data-gs-cap-campo]');
    const esito = radice.querySelector('[data-gs-cap-esito]');
    if (!form || !campo || !esito || elenco.size === 0) return;

    const testo = (chiave) => radice.dataset[chiave] || '';

    const scrivi = (stato, cap) => {
      // Costruito con textContent e non con innerHTML: le stringhe arrivano
      // dalle impostazioni del tema e non c'e' motivo di far passare markup.
      esito.innerHTML = '';
      esito.dataset.stato = stato;

      if (stato === 'errore') {
        const p = document.createElement('p');
        p.className = 'gs-cap__errore';
        p.textContent = testo('gsCapErrore');
        esito.append(p);
        return;
      }

      const stampa = document.createElement('p');
      stampa.className = 'gs-cap__stampa';
      stampa.textContent = cap;

      const verdetto = document.createElement('p');
      verdetto.className = `gs-cap__verdetto gs-cap__verdetto--${stato}`;
      verdetto.textContent = testo(stato === 'zona' ? 'gsCapZonaTitolo' : 'gsCapFuoriTitolo');

      const dettaglio = document.createElement('p');
      dettaglio.className = 'gs-cap__dettaglio';
      dettaglio.textContent = testo(stato === 'zona' ? 'gsCapZonaTesto' : 'gsCapFuoriTesto');

      esito.append(stampa, verdetto, dettaglio);
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const cap = soloCifre(campo.value);
      if (cap.length !== 5) {
        scrivi('errore');
        campo.focus();
        return;
      }
      scrivi(elenco.has(cap) ? 'zona' : 'fuori', cap);
    });

    // Mentre si corregge un CAP sbagliato la risposta di prima resta li' e
    // sembra riferita a quello che si sta scrivendo adesso. Si toglie.
    campo.addEventListener('input', () => {
      const pulito = soloCifre(campo.value);
      if (campo.value !== pulito) campo.value = pulito;
      if (esito.dataset.stato) {
        esito.innerHTML = '';
        delete esito.dataset.stato;
      }
    });
  };

  const avvia = () => document.querySelectorAll('[data-gs-cap]').forEach(attiva);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia, { once: true });
  } else {
    avvia();
  }

  // Nell'editor del tema la sezione viene ricostruita a ogni modifica.
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-gs-cap]').forEach(attiva);
  });
})();
